import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import store from "@/store";
import { Actions } from "@/store/enums/StoreEnums";
import { onBeforeMount } from "vue";
import ManagementSubscription from "@/components/1crm/fitur/management-subscription/index.vue";

export default /*#__PURE__*/_defineComponent({
  props: {
  widgetClasses: String,
},
  setup(__props) {



onBeforeMount(() => {
  store.dispatch(Actions.VERIFY_AUTH_USER);
  setCurrentPageBreadcrumbs("Management Subscribtion", ["Management Fitur"]);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(__props.widgetClasses)
  }, [
    _createVNode(ManagementSubscription)
  ], 2))
}
}

})